const watchlistFields = {
  ip: ["source_ip", "host_ip", "destination_ip", "network_forwarded_ip", "source_nat_ip", "destination_nat_ip"],
  user: ["source_user_name", "user_name", "destination_user_name", "target_user_name"],
  hash: ["hash_md5", "hash_sha1", "hash_sha256", "hash_sha512", "hash_imphash"],
  geolocation: ["source_geo_country_iso", "destination_geo_country_iso", "host_geo_country_iso"],
  domain: ["source_domain", "destination_domain"],
  port: ["source_port", "source_nat_port", "destination_port", "destination_nat_port"],
  file: ["file_name", "file_path"]
};
export default watchlistFields;
